import React from 'react';
import Loader from '../../General/Loader';
import { RecommendationCard } from './RecommendationCard';
import './RowPreview.scss';

const skeletonElements = new Array(6).fill(0);

export const PreviewCards = ({ cards, title, isLoading, message, emptyMessage = 'No cards to display' }) => {
  return (
    <div className='row-preview'>
      {title && <h3 className='row-title'>{title}</h3>}
      {!isLoading && cards && cards.length > 0 && (
        <div className='preview-grid'>
          {cards.map((rec, index) => (
            <div className='recommendation-card' key={index}>
              <div className='rank-badge'>#{index + 1}</div>
              <RecommendationCard id={rec.id} entity={rec.entity} data={rec.data} index={index} />
              <div className='entity-id'>
                {rec.entity} #{rec.id}
              </div>
            </div>
          ))}
        </div>
      )}

      {isLoading && (
        <div className='loading-container'>
          {skeletonElements.map((_, idx) => (
            <div className='skeleton' key={idx}>
              <Loader />
            </div>
          ))}
        </div>
      )}

      {message && !isLoading && <div className='preview-message'>{message}</div>}

      {!isLoading && (!cards || cards.length === 0) && !message && <div className='empty-preview'>{emptyMessage}</div>}
    </div>
  );
};
